// extracted by mini-css-extract-plugin
export default {"switcherSyles":"pure-switcher_switcherSyles__EQZ4S"};